
document.addEventListener('DOMContentLoaded', (event) => {
var PopulerModel = document.querySelector('div#popular_modal1 h2.main_cat_heading.webcat_heading'); 
if(PopulerModel){  
  
  PopulerModel.addEventListener('click', function (event) {
     var modelBtn = document.querySelector('a.more_model1');
         modelBtn.classList.toggle("d_none")
     
  });
  
}  
  
  
//new code sachin
    const wishpopupFirst = document.getElementById('wishlist_popup');

    if (wishpopupFirst) {
      const observer = new MutationObserver(mutationList => {
        mutationList.forEach(mutation => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('.product-store-lists__image img')) {

                var popup_wishlist = node.querySelector('.product-store-lists__image');

                // console.log("Found popup wishlist container:", popup_wishlist);

                // Get all the img elements inside the popup_wishlist
                var images = popup_wishlist.querySelectorAll('img');

                // Iterate through the img elements
                images.forEach(function (img) {
                  // console.log("Processing wishlist image");

                  // Check if the 'srcset' attribute is 'null 1x, null 2x'
                  if (img.getAttribute('srcset') === 'null 1x, null 2x') {
                    // console.log("Invalid srcset found, updating...");

                    // Set the new 'srcset' value with a default image
                    img.setAttribute('srcset', '////husqvarnareplacementparts.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1920x.gif');
                  }
                });
              }
            })
          }
        })
      })
      observer.observe(wishpopupFirst, { childList: true, subtree: true });
    } else {
      console.error('Target element not found');
    }
})
 
var bottomSearch = document.querySelector('.bottom_search'); 

if (bottomSearch) {
  bottomSearch.addEventListener('click', function (event) {
    console.log('check_search');
    
    // Trigger the search input
    var searchInput = document.querySelector('.boost-sd__search-widget-init-input');
    
    if (searchInput) {
      searchInput.click(); // Trigger click on search input
      // OR
      searchInput.focus(); // Focus on search input
    }
    
    var overlay = document.querySelector('.overlay_search');
    if (overlay) {
      event.stopPropagation(); 
      toggleOverlay();
    }   
  });
}

 var openFindmodel = document.getElementById('openFindmodel');
 if(openFindmodel)
 {
 openFindmodel.addEventListener("click", function (e) {
  
 
  var htmlElement = document.querySelector('html');
  if (htmlElement.classList.contains("open_menu")) {
      htmlElement.classList.remove("open_menu");
  }
  var bodyElement = document.querySelector('body');
  if (bodyElement.classList.contains("open_menu")) {
      bodyElement.classList.remove("open_menu");
  }
   var maskOpened  = document.querySelector('.mask-overlay');
    if (maskOpened.classList.contains("mask_opened")) {
      maskOpened.classList.remove("mask_opened");
    }
   
   document.getElementById('ModalLocate').style.display = 'block';
 });
}
 
 
document.addEventListener('click', function (event) {
    var overlay = document.querySelector('.overlay_search');
    if(overlay){
    // Prevent closing if clicking on bottom_search button or overlay itself
    if (overlay.style.display === 'block' && !bottomSearch.contains(event.target) && !overlay.contains(event.target)) {
        toggleOverlay();
    }
      
   }   
});




function toggleOverlay() {
    var overlay = document.querySelector('.overlay_search');
    var searchfooter = document.querySelector('.search-footer');
    var searchfootersvg = bottomSearch.querySelector('.red-color');
    var searchfootersvg_black = bottomSearch.querySelector('.black-color');
    var searchMobile = document.getElementsByClassName('advance_header')[0];
    var advanceSearchP = document.querySelector('.advance_search_p');

    if (overlay.style.display === 'block') {
        // Hide the overlay
        overlay.style.display = 'none';
        overlay.style.pointerEvents = 'none';

        // Reset styles
        searchfootersvg_black.style.display = 'block';
        searchfootersvg.style.display = 'none';
        searchfooter.style.color = '';

        if (advanceSearchP) {
            advanceSearchP.classList.remove('active-class');
        }

        searchMobile.style.position = '';
        searchMobile.style.top = '';
        searchMobile.style.left = '';
        searchMobile.style.zIndex = '';

        document.body.style.overflow = '';
        document.body.style.touchAction = '';
    } else {
        // Show the overlay
        overlay.style.display = 'block';
        // overlay.style.pointerEvents = 'auto';

        searchfootersvg_black.style.display = 'none';
        searchfootersvg.style.display = 'block';
        searchfooter.style.color = '#a50034';

        if (advanceSearchP) {
            advanceSearchP.classList.add('active-class');
        }

        searchMobile.style.position = 'relative';
        searchMobile.style.top = '0';
        searchMobile.style.left = '0';
        searchMobile.style.zIndex = '1000';

        document.body.style.overflow = 'hidden';
        searchMobile.style.pointerEvents = 'auto';
        document.body.style.touchAction = 'none';

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}

     

     


    window.shopUrl = '';
    window.routes = {
      cart_add_url: '',
      cart_change_url: '',
      cart_update_url: '',
      cart_url: '',
      predictive_search_url: ''
    };

     //code updated on 27-03-2024
    let cartBlock = document.querySelector(".cart-block");
    var btnDisable = [];
    var btnDisables = [];
    cartBlock.addEventListener("click", function (e) {
      // e.preventDefault();
      let cartBlock = document.querySelector(".cart-block");
      let checkpop = document.querySelector("#js_cart_popup");
      // document.querySelector('.cms-btn-check').style.display = 'none';
      // document.querySelector('.loading-div').style.display = 'block';

      if (checkpop) {
        // alert('found');
        let get_li_atr = document.querySelectorAll(".list-item .product-item");
        // console.log("get_li_atr", typeof(get_li_atr));
        //   console.log("get_li_atr",get_li_atr.length)

        get_li_atr.forEach(async function (value) {
          var barcode = value.getAttribute('barcode');
          var price = value.getAttribute('price');
          var var_id = value.getAttribute('var_id');
          var sku = value.getAttribute('variant_sku');
          const obj = { variant_basePN: barcode, partpric: price, variant_id: var_id, action: '' }

          if (barcode) {
            // Handle the fetch request
            fetch('https://fridgeparts.us/husqvarnaparts/admin_ajax.php' + '?action=cart_partETA_check&variant_basePN=' + barcode + '&partpric=' + price + '&partvar_id=' + var_id, { method: "POST" })
              .then(response => {
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
                return response.json(); // assuming the response is JSON
              })
              .then(data => {
                // console.log(data); // log or handle the data
                var cat_price = data.price;
                var err_eta = data.errormsg;
                var location_size = data.shipping_loc_size;
                var location_size_city = data.shiping_loc_city;
                var noPurchaseReason = data.noPurchaseReason;
                var status = data.status;
                if (status) {
                  if (status != 'SUCCESS') {
                    value.querySelector('.error_messge').textContent = 'Not Allowed (Please remove it to proceed)';
                    // jQuery('.btnTuluTwo').attr('enabled', 'enabled');
                    btnDisable.push('0');
                  }
                }

                if (noPurchaseReason != '') {
                  console.log("noPurchaseReason")
                  value.querySelector('.error_messge').textContent = 'Not Allowed (Please remove it to proceed.)';
                  // jQuery('.btnTuluTwo').attr('enabled', 'enabled');
                  btnDisable.push('0');
                }

                if (location_size == 1 && location_size_city == 'Greenwood, IN') {
                  value.querySelector('.error_messge').textContent = 'Not available to ship (Please remove it to proceed)';
                  btnDisable.push('0');
                }


                // if(err_eta != '' && err_eta != undefined){
                //   btnDisable.push('0');
                //   value.querySelector('.error_messge').textContent ='Not Allowed (Please remove it to proceed)';
                // }

                if (data.partNumberETA != "") {
                  var res = data.partNumberETA.split("Part Number-");

                  if (res[1] == sku) {
                    value.querySelector('.error_messge').textContent = 'Not available for resale (Please remove it to proceed)';
                  } else {
                    value.querySelector('.error_messge').textContent = 'Substitute Part ' + res[1] + ' is available, please remove ' + sku + ' from Cart and Add ' + res[1] + ' in Cart to Checkout.';
                    //               jQuery('.btnTuluTwo').attr('disabled', 'disabled');
                  }
                  btnDisable.push('0');
                } else {
                  if (data.partEta == 'no longer available') {
                    value.querySelector('.error_messge').textContent = 'No longer available (Please remove it to proceed)';
                    //                 jQuery('.btnTuluTwo').attr('disabled', 'disabled');
                    btnDisable.push('0');
                  }
                }

              })
              .catch(error => {
                console.error('There was a problem with your fetch operation:', error);
              });
          } else {
            rowElm.find('.error_messge').text('This product is not available to order. Please remove it to proceed.');
            //document.querySelector('.cms-btn-check').setAttribute('disabled', 'disabled');
            btnDisable.push('0');
          }
          console.log("btnDisable", btnDisable)

        });


        console.log("btnDisable 111", btnDisable.length)
        setTimeout(function () {
          if (btnDisable.length > 0) {
            //document.querySelector('.cms-btn-check').setAttribute('disabled', 'disabled');
            //document.querySelector('.cms-btn-check').setAttribute('disabled', 'disabled');
            document.querySelector('.cms-btn-check').style.display = 'none';
            document.querySelector('.cms-btn-check').style.display = 'none';
            document.querySelector('.loading-div').style.display = 'none';
          } else {
            //document.querySelector('.cms-btn-check').removeAttribute('disabled');
            document.querySelector('.loading-div').style.display = 'none';
            document.querySelector('.cms-btn-check').style.display = 'flex';
          }
          //$(document).find("#ramsubtotal").text(totalsubtotlprice.toFixed(2));
        }, 5000);
      }

    });


    let deletebtn = document.querySelectorAll(".list-item .delete-item");
    //console.log("deletebtn",deletebtn.length);
    // deletebtn.addEventListener("click",function(e){
    //   e.preventDefault();
    //     window.reload;
    //   })


   
     $(document).ready(function () {
       
      $('#ModalLocate button.close').click(function () {
        // Clear selected values of #category and #subcategory
        $('#category_data').val('');
        $('#subcategory').val('');

        // Remove all child divs from #findModelResult_fmm
        $('#findModelResult_fmm').empty();
      });

       

      $('select option[value="Small Business"]').hide();

      // header mobile search

      $('.js-close-sidebar.close-sidebar-btn').click(function () {
        $('body').removeClass('open_menu');
        setTimeout(function () {
          $('input.search_header__input').val('');
          $('.js-menu-mobile-content.box-menu-moible').removeClass('OnlyMobileSearch');
        }, 500)
      });

      $('.mobile-search').click(function () {
        $('body').addClass('open_menu');
        $('.js-menu-mobile-content.box-menu-moible').addClass('OnlyMobileSearch');
      });
    });




    var MyModel = document.getElementById("MyModel");
    var closeButton1 = document.getElementsByClassName("closed")[0];
    var OpenButton = document.getElementsByClassName("OpenButton");
    closeButton1.onclick = function (e) {
      MyModel.style.display = "none";
    }
    OpenButton.onclick = function (e) {
      MyModel.style.display = "block";
    }


    // JavaScript to open and close the modal
    var ModalLocate = document.getElementById("ModalLocate");
    var OpenModalLocate = document.getElementById("OpenModalLocate");
    var OpenModalLocate1 = document.getElementById("OpenModalLocate1");
    var OpenModalLocate2 = document.getElementById("promo-block-1642094647bb1a667d-0");
    var closeButton = document.getElementsByClassName("close")[0];
 
    if(OpenModalLocate)
    {
    OpenModalLocate.onclick = function (e) {
      //e.preventDefault();
      ModalLocate.style.display = "block";
    }
  }
    if (OpenModalLocate1) {
      OpenModalLocate1.onclick = function (e) {
        // e.preventDefault();
        ModalLocate.style.display = "block";
      }
    }

    closeButton.onclick = function (e) {
      //e.preventDefault();
      ModalLocate.style.display = "none";
      resetModalContent();
    }

    window.onclick = function (event) {
      //event.preventDefault();
      if (event.target === ModalLocate) {
        ModalLocate.style.display = "none";
        resetModalContent();
      }
    }

    // Function to handle the change event of the select box
    let selectBox = document.getElementById("selectBox");
    if (selectBox) {
      selectBox.onchange = function () {
        const selectedOption = selectBox.options[selectBox.selectedIndex];
        const imgSrc = selectedOption.getAttribute('data-img');
        if (imgSrc != '') {

          // Remove existing image if any
          imageContainer.innerHTML = '';

          // Create a new image element and set its attributes
          const imgElement = document.createElement('img');
          imgElement.setAttribute('src', imgSrc);
          imgElement.setAttribute('alt', 'Product Image');

          // Append the image to the imageContainer
          imageContainer.appendChild(imgElement);
        }
      }
    }
    // Function to reset the select box value and empty the imageContainer
    function resetModalContent() {
      // selectBox.selectedIndex = 0;
      // imageContainer.innerHTML = '';
    }

    // };


     function asyncCall(barcode, price, var_id, sku, product_id, variant_quantity) {
      if (barcode) {
        // Handle the fetch request
        jQuery.ajax({
         // url: 'https://fridgeparts.us/bertazzonipartsapp/admin_ajax.php',
    url: 'https://fridgeparts.us/husqvarnaparts/admin_ajax.php',
      type: 'POST',
        async: false,
          data: {
      action: 'get_product_price',

        variant_barcode 	: barcode,
          variant_id    	: var_id,
            product_price		: price,
              product_id    	: product_id,
                variant_quantity  : variant_quantity
    },
    success: function(result) {
      // console.log("result",result);

      jQuery('#ComparePrice').css('display', 'none');
      var response = JSON.parse(result);
      setTimeout(function () {

        var location_size = response.shipping_loc_size;
        var location_size_city = response.shiping_loc_city;
        const date = new Date();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        // This arrangement can be altered based on how we want the date's format to appear.
        let currentDate = `${month}/${day}/${year}`;

        if (location_size == 1 && location_size_city == 'Greenwood, IN') {

          $(document).find('#AddToCart').attr("disabled", "true");
          $(document).find('#AddToCart').addClass("disabled");
          $(document).find('.btnAddToCart span').text("Sold Out");
          $(document).find('.js_product_single .productAvailability1').addClass("outstock productAvailability");
          $(document).find('.js_product_single .productAvailability1').addClass("pro_outofstock productAvailability");
          $(document).find('.js_product_single .productAvailability1').removeClass("instock");
          $('#noPurchaseReason').text(response.noPurchaseReason);
          $('.pro-details').css('display', 'none');
          $('.noPurchaseReason').css('display', 'block');
          $('p#noPurchaseReason').css('display', 'block');
          jQuery('.cms-product-meta').hide();
          //shopify-payment-button__button
          setTimeout(function () { $(document).find('.shopify-payment-button__button').hide(); }, 3000)
          return;
        }

        if (response.partEta == "no longer available") {
          $(document).find(".notify_button").css("display", "none");
          $(document).find(".group-quantity-button").css("display", "none");
        } else if (response.partEta == "invalid product id" || response.partEta == "Not Allowed") {
          jQuery('.product-form--atc-button').attr("disabled", "true");
          jQuery('.product-form--atc-button').addClass("disabled");
          jQuery(document).find(".subsitutemsg").show();
          jQuery(".search-model").hide();
          jQuery('.cms-product-meta').hide();
          jQuery(".subsitutemsg").append('<div class="subscontent"><p style="color:red;text-transform: capitalize" class="subsmaincontent">' + response.partEta + '</p></div>');
          setTimeout(function () { $(document).find('.shopify-payment-button__button').hide(); }, 3000)
          return;
        } else {
          //$(document).find(".notify_button").css("display","block");
        }
        if (response.noPurchaseReason != '' && response.partEta != 'no longer available' || response.noPurchaseReason != '' && response.partEta != 'use substitute part') {
          var nopur = response.substitutePartLink;
          let use_sub_prt = response.noPurchaseReason;
          let check_strings = use_sub_prt.includes("use substitute part");
          if (check_strings) {
            let partNums = use_sub_prt.split(" ");
            let chk_partNums = partNums[5];
            let partNumssss = chk_partNums.split("<");
            partNumssss = partNumssss[0]
            let links = `Use Substitute Part <b>${partNumssss}<b>`;
            $(".more-info").append(` <p>This part is no longer available, but the part listed below is comparable and can be used instead</p>
                                  <p class="sub">View Substitute Part # <a href="/products/${partNumssss}">${partNumssss}</a></p>
                                  <a href="/products/${partNumssss}">View Part</a>`);
            $(".product-iteam").show();
            // jQuery('#noPurchaseReason').html(links);
          } else {
            $('#noPurchaseReason').text(response.noPurchaseReason);
            $('.noPurchaseReason').css('display', 'block');
            $('p#noPurchaseReason').css('display', 'block');
          }

          $('.pro-details').css('display', 'none');
          $(document).find('.group-quantity-button').css('display', 'none')

          $('#AddToCart').attr("disabled", "true");
          $('#AddToCart').addClass("disabled");
          $('#AddToCart').hide();
          jQuery('.cms-popup-quickview .cms-product-meta').hide();
          jQuery('#AddToCart').attr("disabled", "true");
          jQuery('#AddToCart').addClass("disabled");
          jQuery('#AddToCart').hide();
          setTimeout(function () { $(document).find('.shopify-payment-button__button').hide(); }, 10000)
          // jQuery(".search-model").hide();
          if (nopur) {
            //comment Call GraphQl api for getting the newPartnumber's Handle


            var link = `Use Substitute Part <a href="/products/${nopur}"> ${nopur}</a>`;
            jQuery('#noPurchaseReason').html(link);
          }
        }
        if (response.noPurchaseReason.includes('no longer available - 004') || response.noPurchaseReason == 'Invalid Price - 002' || response.noPurchaseReason == 'not available for purchase - 015') {
          $('#noPurchaseReason').text(response.noPurchaseReason);
          $('.pro-details').css('display', 'none');
          $('.noPurchaseReason').css('display', 'block');
          $('p#noPurchaseReason').css('display', 'block');

          var check_br_tag = response.noPurchaseReason.includes("<br")
          // console.log("2",check_br_tag);
          if (check_br_tag) {
            var new_pr_rsn = response.noPurchaseReason.split("<br");
            // console.log("2 in",new_pr_rsn);
            $('#noPurchaseReason').text(new_pr_rsn[0]);
          } else {
            $('#noPurchaseReason').text(response.noPurchaseReason);
          }
          $('#AddToCart').attr("disabled", "true");
          $('#AddToCart').addClass("disabled");
          $('#AddToCart').hide();
          jQuery('.product-form--atc-button').attr("disabled", "true");
          jQuery('.product-form--atc-button').addClass("disabled");
          jQuery('#AddToCart').attr("disabled", "true");
          jQuery('#AddToCart').addClass("disabled");
          jQuery('#AddToCart').hide();
          jQuery('.cms-popup-quickview .cms-product-meta').hide();
          setTimeout(function () { $(document).find('.shopify-payment-button__button').hide(); }, 10000)
          // jQuery(".search-model").hide();
          jQuery('.cms-popup-quickview .productAvailability1').html("<label>Availability<span class='colon'> : </span</label><span class='outstock'> " + response.noPurchaseReason + "</span>");
          //return;
        }

        if (response.newPartNumber) {
          var newPartNumber = response.newPartNumber;
          newPartNumber = newPartNumber.replace("/", "-");
          var originalPart = response.originalPart;
          if (newPartNumber != originalPart) {

            //comment Call GraphQl api for getting the newPartnumber's Handle

            // console.log(newPartNumber,"newPartNumber")

            // Replace 'YOUR_STOREFRONT_ACCESS_TOKEN' with your actual Storefront API token
            const storefrontAccessToken = '54acc1c14a2230bec16a4e9c3cf02688';

            async function getHandle() {
              var proHandleDet = [];

              const resData = await fetch("https://husqvarna-parts.myshopify.com/api/2023-04/graphql.json", {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                },

                body: JSON.stringify({
                  query: `{
                          products(query: "${newPartNumber}", first: 10) {
                            nodes { 
                              handle                
                            }
                          }
                        }
                        `,
                }),
              });


              // console.log("resData",resData)

              const handleResult = await resData.json();
              // console.log("handleResult",handleResult)

              if (handleResult.data.products) {
                proHandleDet.push(handleResult.data.products);
              }
              // }

              // console.log(proHandleDet,"proHandleDet");

              proHandleDet[0].nodes.forEach(product => {
                const { title, description, variants, handle, images } = product;
                // console.log("handle1212",handle)
                // $(".subsitutemsg").css("display","block");
                $(".cms-popup-quickview .cms-product-meta.clearfix").css("display", "none");
                $('.group-button-buyitnow ').css("display", "none");
                $(".more-info").append(` <p>This part is no longer available, but the part listed below is comparable and can be used instead</p>
                              <p class="sub">View Substitute Part # <a href="/products/${handle.toLowerCase()}">${newPartNumber}</a></p>
                              <a href="/products/${handle.toLowerCase()}">View Part</a>`);
                $(".product-iteam").show();
                //$(".subsitutemsg").append('<div class="subscontent"><p class="subsmaincontent"> This part is no longer available, but the part(s) listed below is comparable and can be used instead. ! <br/> View Substitute part : <a href="/products/'+handle.toLowerCase()+'">'+newPartNumber+'</a></p></div>  <div class="subslink"><a class="btn redirectedbtn" href="/products/'+handle.toLowerCase()+'"><b>View Part</b></a></div>');          
                $('.cms-popup-quickview .productAvailability1').html("<label>Availability : </label><span class='outstock'> Out of Stock </span>");
                // console.log("handle",handle)

              });
            }

            getHandle();

            setTimeout(function () {
              setTimeout(function () { $(document).find('.shopify-payment-button__button').hide(); }, 3000)
            }, 3000)


            return;
          }
        }
        if (response.quantity != 0 && response.quantity != -999) {
          var quantity = response.quantity;
          jQuery('#AddToCart').removeAttr("disabled");
          jQuery('#AddToCart').removeClass("disabled");

          jQuery('.cms-popup-quickview .productAvailability1').addClass("instock productAvailability");
          jQuery('.cms-popup-quickview .productAvailability1').removeClass("outstock");
          jQuery('.cms-popup-quickview .productAvailability1').removeClass("pro_outofstock");
          if (product_id != '') {//5501745430684
            jQuery('.cms-popup-quickview .productAvailability1').html("<label>Availability : </label><span class='instock'>In Stock</span>");//<span> - order placed today by 3pm EST will ship <span class='guaranteed_tooltip'><span class='guaranteed'><b>today</b></span><div class='gttooltip'><div class='tooltip_Content'><div class='tooltip_header'><p class='oadatb-button' oada-type='button'>Fast, Convenient Delivery!</p></div><p>We know you need your parts shipped and delivered FAST!</p><p style='font-size: 15px!important; font-weight: 600!important; line-height: 20px!important; color: #000!important;'>Any IN STOCK order placed today by 3pm will ship TODAY or you will receive 20% off your next order.</p><p>We strive to provide you with the most accurate ETAs and updates for Out of Stock items.</p></div></div></span></span>
          } else {
            jQuery('.productAvailability1').html("<label>Availability : </label><span class='instock'>In Stock</span>");
          }
        } else {

          var quantity = response.quantity;
          var partEta = response.partEta;

          if (partEta == 'no longer available') {
            jQuery('.product-form--atc-button').attr("disabled", "true");
            jQuery('.product-form--atc-button').addClass("disabled");
            $(".cms-popup-quickview .cms-product-meta.clearfix").css("display", "none");
            setTimeout(function () { $(document).find('.shopify-payment-button__button').hide(); }, 3000)
            jQuery('.cms-popup-quickview .productAvailability1').addClass("outstock productAvailability");
            jQuery('.cms-popup-quickview .productAvailability1').addClass("pro_outofstock productAvailability");
            jQuery('.cms-popup-quickview .productAvailability1').removeClass("instock");
            jQuery('.cms-popup-quickview .productAvailability1').html("<label>Availability : </label><span class='outstock'> Out of stock  " + response.partEta + "</span>");
          } else if (partEta == 'Today' && newPartNumber == '') {
            jQuery('.productAvailability1').html("<label>Availability : </label> <span itemprop='availability' content='https://schema.org/InStock' class='instock'>In Stock </span>" + partEta + "");
            jQuery('#AddToCart').removeAttr("disabled");
            jQuery('#AddToCart').removeClass("disabled");
            jQuery('.btnAddToCart span').text("Add to Cart");
            jQuery('#AddToCart').show();
            jQuery('.cms-popup-quickview .productAvailability1').removeClass("outstock productAvailability");
            jQuery('.cms-popup-quickview .productAvailability1').removeClass("pro_outofstock productAvailability");
            jQuery('.cms-popup-quickview .productAvailability1').addClass("instock");
            //jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
          } else if (partEta == 'No ETA - Factory Backorder') {

            jQuery('.cms-popup-quickview .productAvailability1').html("<label>Availability : </label> <span class='instock'> </span>" + partEta + "");
            jQuery('#AddToCart').removeAttr("disabled");
            jQuery('#AddToCart').removeClass("disabled");
            //jQuery('.btnAddToCart span').text("Add to Cart");
            jQuery('.cms-popup-quickview .productAvailability1').removeClass("outstock productAvailability");
            jQuery('.cms-popup-quickview .productAvailability1').removeClass("pro_outofstock productAvailability");
            jQuery('.cms-popup-quickview .productAvailability1').addClass("instock");
            //jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
          } else if (partEta == 'No ETA - Delivery Not Available') {
            jQuery('.productAvailability1').html("<label>Availability : </label> <span style='color:red' class='outstock'>" + partEta + "</span>");
            jQuery('#AddToCart').removeAttr("disabled");
            jQuery('#AddToCart').removeClass("disabled");
            jQuery('.btnAddToCart span').text("Add to Cart");
            jQuery('.cms-popup-quickview .productAvailability1').removeClass("outstock productAvailability");
            jQuery('.cms-popup-quickview .productAvailability1').removeClass("pro_outofstock productAvailability");
            jQuery('.cms-popup-quickview .productAvailability1').addClass("instock");
            //jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
          } else {


            if (response.noPurchaseReason != "not available for purchase - 015") {
              // console.log("else if ETA" ,response.noPurchaseReason)
              jQuery('.product-form--atc-button').removeAttr("disabled");
              jQuery('.product-form--atc-button').removeClass("disabled");


              jQuery('.cms-popup-quickview .productAvailability1').addClass("outstock productAvailability");
              jQuery('.cms-popup-quickview .productAvailability1').addClass("pro_outofstock productAvailability");
              jQuery('.cms-popup-quickview .productAvailability1').removeClass("instock");
              jQuery('#AddToCart').show();
            } else {
              $(".cms-popup-quickview .cms-product-meta.clearfix").css("display", "none");
              jQuery('#AddToCart').hide();
              // console.log("else if else 3 ETA" ,response.noPurchaseReason)
            }
            var newpartseta = partEta.includes('or');

            var ETA = '';
            if (newpartseta) {
              ETA = partEta.split('or');
              ETA = ETA[0];
            } else {
              ETA = partEta;
            }
            //console.log(ETA);
            // jQuery('.cms-popup-quickview .productAvailability1').html("<label class='avail' >Availability : </label> <span class='outstock'>Ships by </span>" + currentDate + " - " + ETA);
            jQuery('.cms-popup-quickview .productAvailability1').html("<label class='avail' >Availability: </label> <span class='outstock'>Expected to be available on </span>"+ETA);
          }

        }
        if (response.price != "") {
          var price = response.price;
          jQuery('#js-product-price').text(price);
        }
        if (response.old_price != "") {
          jQuery('.product-old-price').css('display', 'block');
          jQuery('.save-price').append(response.save_price);
          jQuery('.old-amount').append(response.old_price);
        }
        if (response.core_price != "0.00") {
          jQuery('.part_core_price').css('display', 'block');
          jQuery("li.part_price").find('span').text(response.part_price);
          jQuery("li.core_price").find('span').text(response.core_price);
        }

      }, 7000)
    }
                
               
             })

        }else {

      $("#MyModel").find('.ModelBody').text(`This product is not available to order. Please remove it to proceed.`);
      $(this).find('.loaderbuynow').css("display", "none");
      $("#MyModel").show();
      // value1.querySelector('.error_messge').textContent = 'This product is not available to order. Please remove it to proceed.';
      //document.querySelector('.cms-btn-check').setAttribute('disabled', 'disabled');
      btnDisables.push('0');
      return;
    }
      };

    // setTimeout(function(){

    //var awaitlengths = await (btnDisables.length);

    // console.log("awaitlengths",awaitlengths)

    // if(awaitlengths < 1){
    //   // callchekcout(var_id)
    // }

    // },3000)



    //   }
    // }







    // $(document).on("click", ".minicart", function (e) {
    //   $('.popup.js-popup .mask-overlay').addClass('mask_opened');
    //   $('html').addClass('hside_opened pside_opened');

    // });
    // $(document).on("click",".minicart",function(e){
    //    $('.popup.js-popup .mask-overlay').removeClass('mask_opened');  
    // });


    $(document).on("click", ".buy_now", function (e) {
      e.preventDefault();
      // $(this).find('.text').css("display","none");
      //$(this).find('.loaderbuynow').css("display","inline-block");
      var barcode = $(this).attr('barcode');
      var price = $(this).attr('price');
      var var_id = $(this).attr('data-pid');
      var sku = $(this).attr('skus');
      var product_id = $(this).attr('product_id');
      var variant_quantity = $(this).attr('variant_quantity');
      const obj = { variant_basePN: barcode, partpric: price, variant_id: var_id, action: '' }

      if (price != '$0.00') {
        $('.priceProduct').text(price);
        $('#js-product-price').text(price);
      } else {
        $('#js-product-price').css('display', 'none');
        $('#AddToCart').attr("disabled", "true");
        $('#AddToCart').addClass("disabled");
        $('.btnAddToCart span').text("Sold Out");
        $('.cms-popup-quickview .productAvailability1').addClass("outstock productAvailability");
        $('..cms-popup-quickview .productAvailability1').addClass("pro_outofstock productAvailability");
        $('..cms-popup-quickview .productAvailability1').removeClass("instock");
        // return;
      }

      // console.log("obj",obj)

      asyncCall(barcode, price, var_id, sku, product_id, variant_quantity)



    })



    function callchekcout(var_id) {
      // setTimeout(function(){
      // console.log("btnDisables",btnDisables)
      if (btnDisables.length > 0) {
        //document.querySelector('.cms-btn-check').style.display = 'none';
        //document.querySelector('.cms-btn-check').style.display = 'none';
        $(this).find('.loaderbuynow').css("display", "none");
      } else {
        let formData = {
          'items': [{
            'id': var_id,
            'quantity': 1
          }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => {
            $(this).find('.loaderbuynow').css("display", "none");
            // console.log("response",response)
            window.location = "/checkout"
            // return response.json();
          })
          .catch((error) => {

            $(".OpenButton").find('.ModelBody').text(`There was a problem with This product ${error}.`);
            $(this).find('.loaderbuynow').css("display", "none");
            $(".OpenButton").show();
            console.error('Error:', error);
            return;
          });


      }

      // }, 3000);
    }

     
      var modelsArr = [
      {
        "category": "TV & Home Theater",
        "sub_category": [
          { "name": "TVs", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/TVs.png" },
          { "name": "Home Video", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Home_Video.png" },
          { "name": "TV & Home Theater Accessories", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/TV_Home_Theater_Accessories.png" }
        ]
      },
      {
        "category": "Washers & Dryers",
        "sub_category": [
          { "name": "Washers", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Washers.png" },
          { "name": "Washer Dryer Combos", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Washer_Dryer_Combos.png" },
          { "name": "Dryers", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Dryers.png" },
          { "name": "Styler Steam Clothing Care System", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Styler_Steam_Clothing_Care_System.png" }
        ]
      },
      {
        "category": "Kitchen",
        "sub_category": [
          { "name": "Dishwashers", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Dishwasher_80e1e307-fe00-4fd6-9d9a-6d6cf4a29ccc.png" },
          { "name": "Refrigerators", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Refrigerator.png" },
          { "name": "Cooking Appliances", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Cooking_Appliances.png" }
        ]
      },
      {
        "category": "Computing",
        "sub_category": [
          { "name": "Monitors", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Monitor.png" },
          { "name": "Burners & Drives", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Burners_Drives.png" },
          { "name": "IT Monitor", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/IT_Monitor.png" },
          { "name": "Laptops", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Laptop.png" }
        ]
      },
      {
        "category": "Other Appliances",
        "sub_category": [
          { "name": "Air Conditioners", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Air_Conditioner.png" },
          { "name": "Vacuums", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Vacuums.png" }
        ]
      },
      {
        "category": "Audio",
        "sub_category": [
          { "name": "Headphones", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Headphones.png" },
          { "name": "Home Audio", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Home_Audio.png" }
        ]
      },
      {
        "category": "Mobile",
        "sub_category": [
          { "name": "Bluetooth Headsets & Headphones", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Bluetooth_Headsets_Headphones.png" },
          { "name": "Cell Phones", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Mobile_b9e11f21-d347-409f-9469-472c1760f3f6.png" },
          { "name": "Tablets", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Tablet.png" },
          { "name": "Smart Watches", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Smart_Watches.png" }
        ]
      },
      {
        "category": "Commercial Display",
        "sub_category": [
          { "name": "Healthcare TVs", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Healthcare_TVs.png" },
          { "name": "Commercial OLED", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Commercial_OLED.png" },
          { "name": "Outdoor Displays", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Outdoor_Displays.png" },
          { "name": "Video Walls", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Video_Walls.png" },
          { "name": "Digital Signage", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Digital_Signage.png" },
          { "name": "Commercial TVs", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Commercial_TVs.png" },
          { "name": "Hospitality TVs", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/Hospitality_TVs.png" }
        ]
      },
      {
        "category": "Solar",
        "sub_category": [
          { "name": "LG Technology", "image": "https://cdn.shopify.com/s/files/1/0523/4003/1667/files/LG_Technology.png" }
        ]
      }
    ];



    $('.close').click(function () {
      $('.modal_find').css('display', 'none');
    })


    jQuery(document).ready(function () {

      //    jQuery.ajax({
      //      url: 'https://fridgeparts.us/lgparts/admin_ajax.php',
      //      type: 'POST',
      //      data: {
      //        action: 'get_find_model_category',
      //      },
      //      success : function(response) {
      //        var responseArr = JSON.parse(response);
      //        if(responseArr.status == true) {
      jQuery("#category_data").html('<option value="">Select Category</option>');

      for (var i = 0; i < modelsArr.length; i++) {
        var category = modelsArr[i].category;
        jQuery("#category_data").append('<option value="' + category + '">' + category + '</option>');
      }
      //      }
      //   }
      // });


      // Handle category change
      $(document).on('change', '#category_data', function () {
        var selectedCategory = $(this).val();
        $("#subcategory").empty().append('<option value="">Select Subcategory</option>'); // Clear existing subcategories

        for (var i = 0; i < modelsArr.length; i++) {
          if (modelsArr[i].category === selectedCategory) { // Match selected category
            var subCategories = modelsArr[i].sub_category || []; // Ensure sub_category exists

            for (var j = 0; j < subCategories.length; j++) {
              jQuery("#subcategory").append(
                '<option value="' + subCategories[j].name + '" data-image="' + subCategories[j].image + '">' +
                subCategories[j].name +
                '</option>'
              );
            }
            break; // Exit loop once category is found
          }
        }
      });
      $(document).on('change', '#subcategory', function () {
        var subcategory = $(this).val();

        // jQuery.ajax({
        //    url: 'https://fridgeparts.us/lgparts/admin_ajax.php',
        //    type: 'POST',
        //    data: {
        //      action: 'get_find_model_data',
        //      subcategory: subcategory
        //    },
        //    success : function(response) {
        //      var responseArr = JSON.parse(response);
        //      // console.log("responseArr",responseArr)
        //      if(responseArr.status == true) {
        jQuery(".migration-contents").html('');
        // var modelsArr = responseArr.result;
        // for(var i = 0; i < modelsArr.length; i++) {
        //   var description = modelsArr[i].description;
        //   var image = modelsArr[i].image;
        var selectedOption = $(this).find(':selected');
        var image = selectedOption.data('image');
        console.log("image", image);
        var onerror_image = 'https://www.lg.com/us/content/img/support/img-dummy-product.jpg';
        jQuery(".migration-contents").addClass('active');
        // <div class="find-text">'+description+'</div>
        jQuery(".migration-contents").append(`<p class="find-img"><img src="${image}" onerror="this.src='${onerror_image}'" alt="Washers(FrontLoad)"></p>`);
        //          }
        //      }
        //   }
        // });
      });

    });

   

    // document.getElementById('model_close').addEventListener('click', function () {
    //   document.body.classList.remove('modal-open');
    // });

    // js for popup

   

    document.addEventListener('DOMContentLoaded', (event) => {
      const closeButton = document.querySelector('.close');
      const htmlElement = document.documentElement; // Selects the <html> element
      var menu = document.querySelector('.box-menu-moible');
      var backgrnd = document.querySelector('.js-mobile_bkg_show');
      var maskopened = document.querySelector('.mask-overlay')
      closeButton.addEventListener('click', () => {
        // htmlElement.classList.add('open_menu');
        htmlElement.classList.remove('open_show');
        menu.style.display = 'block';
        backgrnd.style.position = 'relative';
        maskopened.style.display = 'none';

      });
    });

    $(document).ready(function () {
      // Click handler for opening quick view
      $('.js_quick_view').on('click', function () {
        $('body').addClass('overlay-active');
      });

      // Click handler for closing quick view
      $(document).on('click', '.mfp-close', function () {
        $('body').removeClass('overlay-active');
      });
    });
    $(document).ready(function () {

      $(".adcartwish").click(function () {
        alert('Item selected');
      });
    });

   //   document.addEventListener('mouseleave', function(event) {
    //     //if (event.clientY < 0) {
    //     document.getElementById('exitPopup').style.display = 'flex';
    //     $("body").addClass("popupopen");
    //     //}
    //     });
    //   function closePopup(){
    //       console.log(document.getElementById('closePopup'))

    //     document.getElementById('exitPopup').style.display = 'none';
    //     $("body").removeClass("popupopen");
    //       }
    //   function copyToClipboard() {
    //       var copyText = document.getElementById("discountCode");
    //       copyText.select();
    //       copyText.setSelectionRange(0, 99999); // For mobile devices

    //       // Copy the text inside the text field
    //       document.execCommand("copy");

    //       // Alert the copied text (optional)

    //    document.getElementById('exit_message').style.display = 'block';



    //          document.getElementById('exitPopup').style.display = 'none';
    //          $("body").removeClass("popupopen");
    //           setTimeout(function() {
    //   document.getElementById('exit_message').style.display = 'none';
    // }, 10000);
    //       }

    var orderPage = document.getElementById("order");
    var ProfilePage = document.getElementById("profile");
    if (ProfilePage) {
      ProfilePage.addEventListener("click", function () {
        document.getElementById("accoutprofile").classList.add("highlight");
        ProfilePage.classList.add("btnhighlight")
        document.getElementById("orderhistory").classList.remove("highlight");
        orderPage.classList.remove("btnhighlight");
      });


      // Remove class on 'Remove Class' button click
      if(orderPage){
        orderPage.addEventListener("click", function () {
          document.getElementById("accoutprofile").classList.remove("highlight");
          ProfilePage.classList.remove("btnhighlight");
          
           document.getElementById("orderhistory").classList.add("highlight");
           orderPage.classList.add("btnhighlight");
        });
      }  


      
    

    }

    document.addEventListener('DOMContentLoaded', function () {

      var quoteElement = document.querySelector('.cms_content_quote p');
      if (quoteElement) {
        var originalText = quoteElement.textContent;
        if (originalText.length > 40) {
          var truncatedText = originalText.substring(0, 40) + '...';
          quoteElement.textContent = truncatedText;
        }
      }
    });


// not in index 
      if(document.getElementById("DofindTrigger")){
       document.getElementById("DofindTrigger").addEventListener("click", function () {
        const alosearchElement = document.querySelector("input.search_header__input.js_iput_search");
        if (alosearchElement) {
          alosearchElement.click();
        }
      });
    }  
    

    // Get the modal
    var modal = document.getElementById("ocrModal");
    let canvas = document.querySelector("#canvas");
    let lorem_ipsum_div = document.querySelector(".lorem_ipsum_div");
    let ScanImg = document.querySelector(".ScannerImg");
    let scan_now_btn = document.querySelector(".scan_now_btn");



    // Get the button that opens the modal
    var btn = document.getElementById("myBtn");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("ocrclose")[0];

    // When the user clicks on the button, open the modal


    // When the user clicks on <span> (x), close the modal
    span.onclick = function () {
      modal.style.display = "none";
      lorem_ipsum_div.style.display = "block";
      ScanImg.style.display = "block";
      scan_now_btn.style.display = "block";

    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }


    var scannInput = document.querySelector('input[type=file]'); 

    scannInput.onclick = function () {
      modal.style.display = "block";
      lorem_ipsum_div.style.display = "none";
      ScanImg.style.display = "none";
      scan_now_btn.style.display = "none";

    }

    // let camera_button = document.querySelector("#start-camera");
    // let video = document.querySelector("#video");

    var ctx = canvas.getContext("2d");
    var cw = canvas.width;
    var ch = canvas.height;
    var maxW = 360;
    var maxH = 400;

    scannInput.addEventListener('change', handleFiles);

    function handleFiles(e) {
      var img = new Image;
      img.onload = function () {
        var iw = img.width;
        var ih = img.height;
        var scale = Math.min((maxW / iw), (maxH / ih));
        var iwScaled = iw * scale;
        var ihScaled = ih * scale;
        canvas.width = iwScaled;
        canvas.height = ihScaled;
        ctx.drawImage(img, 0, 0, iwScaled, ihScaled);

        let image_data_url = canvas.toDataURL("image/jpeg", 0.5) //'image/jpeg'
        var Parameters = "image=" + image_data_url;
        $.ajax({
          type: "POST",
          url: "https://fridgeparts.us/bertazzonipartsapp/ocr/ocr_redirect.php",
          data: Parameters,
          contentType: "application/x-www-form-urlencoded",
          cache: false,
          success: function (data) {
            const highlightsContainer = document.getElementById('matcheshighlights');
            const img = document.getElementById('ocrimages');

            data.forEach(item => {
              const highlight = document.createElement('div');
              highlight.className = 'highlight';
              highlight.setAttribute("text", item.content);
              highlight.style.left = item.bounds.x1 + 'px';
              highlight.style.top = item.bounds.y1 + 'px';
              highlight.style.width = (item.bounds.x2 - item.bounds.x1) + 'px';
              highlight.style.height = (item.bounds.y2 - item.bounds.y1) + 'px';
              highlightsContainer.appendChild(highlight);
            });

            $(".ocrmodal").show();

            document.querySelectorAll(".highlight").forEach(function (highlightocr) {
              highlightocr.addEventListener("click", function () {
                // Get the innerText of the clicked element
                const text = highlightocr.getAttribute("text");
                const setsrchval = document.querySelector(".search_header__input");
               window.location.href = "/#335f/mobile/m=and&q=" + text;
                location.reload()
                //setsrchval.setAttribute('value',text);
                // document.querySelector(".search_header__submit").click();
              });
            });
          }
        }).done(function () {

        });

      }
      img.src = URL.createObjectURL(e.target.files[0]);
    } 



  // document.querySelector('.scanner').addEventListener('click', function () {
  //     document.querySelector('.main').style.display = 'none'; // Hide the overall_div
  //     document.querySelector('.header').style.display = 'none'; // Hide the overall_div
  //     document.querySelector('.container_div').style.display = 'block';
  //     // document.querySelector('body').classList.add('body-hidden'); // Add the body-hidden class to hide the body
  //   });

  //   // Add an event listener to remove the 'body-hidden' class and show the body content again
  //   document.querySelector('.close-icon').addEventListener('click', function () {
  //     document.querySelector('.main').style.display = 'block'; // Hide the overall_div
  //     document.querySelector('.header').style.display = 'block'; // Hide the overall_div
  //     document.querySelector('.container_div').style.display = 'none';
  //     // document.querySelector('body').classList.remove('body-hidden'); // Remove the body-hidden class
  //   });



  document.querySelectorAll(".advance_search_p").forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();  // Prevents the default behavior of the anchor tag (scrolling to top)

      // Show the popup and overlay
      document.getElementById("popup").style.display = "block";
      document.querySelector('body').classList.add('body-hidden');
      document.getElementById("overlay").style.display = "block";
    });
  });
  if (document.getElementById("close_popup")) {
    document.getElementById("close_popup").addEventListener("click", function (event) {
      event.preventDefault();  // Prevents the default behavior of the anchor tag
      document.querySelector('body').classList.remove('body-hidden');
      // Hide the popup and overlay
      document.getElementById("popup").style.display = "none";
      document.getElementById("overlay").style.display = "none";
    });
  }





  document.querySelector('.scanner').addEventListener('click', function () {
        // alert("Scanner Clicked");
    document.querySelector('.main').style.display = 'none'; // Hide the overall_div
    document.querySelector('.header').style.display = 'none'; // Hide the overall_div
    document.querySelector('.container_div').style.display = 'block';
    document.querySelector('body').classList.add('body-hidden'); // Add the body-hidden class to hide the body
  });

  // Add an event listener to remove the 'body-hidden' class and show the body content again
  document.querySelector('.close-icon').addEventListener('click', function () {
        // alert("sScanner Closed");
    document.querySelector('.main').style.display = 'block'; // Hide the overall_div
    document.querySelector('.header').style.display = 'block'; // Hide the overall_div
    document.querySelector('.container_div').style.display = 'none';
    document.querySelector('body').classList.remove('body-hidden'); // Remove the body-hidden class
  });




//  document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll('a.scanner').forEach(function (el) {
//     el.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation(); // VERY IMPORTANT

//       console.log("Scanner clicked ");
//             alert("Scanner Clicked");


//       let container = document.querySelector('.container_div');

//       if (container) {
//         container.style.display = 'block';
//       }

//       document.querySelector('.main')?.style.setProperty('display', 'none', 'important');
//       document.querySelector('.header')?.style.setProperty('display', 'none', 'important');
//     });
//   });

// });




  if (window.innerWidth < 1025) {




    const headers = document.querySelectorAll('.custom-accordion-header');

    headers.forEach(header => {
      header.addEventListener('click', () => {
        const content = header.nextElementSibling;
        const accordionItem = header.parentElement;

        // Close all other open accordions
        headers.forEach(otherHeader => {
          const otherContent = otherHeader.nextElementSibling;
          const otherItem = otherHeader.parentElement;

          if (otherContent !== content) {
            otherContent.classList.remove('is-visible');
            otherItem.classList.remove('active');
            otherHeader.querySelector('.custom-accordion-toggle').textContent = '+';
          }
        });

        // Toggle the current accordion
        content.classList.toggle('is-visible');
        if (content.classList.contains('is-visible')) {
          accordionItem.classList.add('active');
          header.querySelector('.custom-accordion-toggle').textContent = '-';
        } else {
          accordionItem.classList.remove('active');
          header.querySelector('.custom-accordion-toggle').textContent = '+';
        }
      });
    });


  }

 document.addEventListener("DOMContentLoaded", function () {
    // Function to toggle visibility of a menu and its arrows
    function toggleMenu(button, menu) {
      const upArrow = button.querySelector(".up_arrow");
      const downArrow = button.querySelector(".down_Arrow");

      if (menu.style.display === "none" || menu.style.display === "") {
        menu.style.display = "block";
        upArrow.style.display = "block";
        downArrow.style.display = "none";
      } else {
        menu.style.display = "none";
        upArrow.style.display = "none";
        downArrow.style.display = "block";
      }
    }

    // Function to close all menus and reset all arrows
    function closeAllMenus() {
      const allMenus = document.querySelectorAll(".menu-item_custom");
      const allArrows = document.querySelectorAll(".btn_class");

      allMenus.forEach((menu) => (menu.style.display = "none"));
      allArrows.forEach((button) => {
        const upArrow = button.querySelector(".up_arrow");
        const downArrow = button.querySelector(".down_Arrow");
        upArrow.style.display = "none";
        downArrow.style.display = "block";
      });
    }

    // Attach click events to primary menu buttons
    const buttons = document.querySelectorAll(".btn_class");
    buttons.forEach((button) => {
      const menuId = button.getAttribute("aria-label").split("-")[1]; // Get menu ID
      const menu = document.getElementById("menu-items-" + menuId);

      button.addEventListener("click", function () {
        if (menu.style.display === "block") {
          toggleMenu(button, menu); // Close if open
        } else {
          closeAllMenus(); // Close all other menus
          toggleMenu(button, menu); // Open the clicked menu
        }
      });
    });

    // Attach click events to submenu buttons
    const submenuButtons = document.querySelectorAll(".btn_data");
    submenuButtons.forEach((button) => {
      const submenu = button.nextElementSibling; // The submenu is the next sibling
      const upArrowMenu = button.querySelector(".up_arrow_menu");
      const downArrowMenu = button.querySelector(".down_Arrow_menu");
      const submenuList = submenu.querySelector("ul");

      // Check if submenu `<ul>` is empty
      if (!submenuList || submenuList.children.length === 0) {
        // Hide arrows and disable click functionality
        upArrowMenu.style.display = "none";
        downArrowMenu.style.display = "none";
        // button.style.pointerEvents = "none"; // Disable clicks
        button.style.cursor = "default";
      } else {
        button.addEventListener("click", function () {
          // Check if this submenu is already open
          if (submenu.style.display === "block") {
            // If open, close it
            submenu.style.display = "none";
            upArrowMenu.style.display = "none";
            downArrowMenu.style.display = "block";
          } else {
            // First, close all other submenus
            const allSubmenus = document.querySelectorAll(".submenu");
            allSubmenus.forEach((item) => (item.style.display = "none"));

            const allUpArrows = document.querySelectorAll(".up_arrow_menu");
            const allDownArrows = document.querySelectorAll(".down_Arrow_menu");
            allUpArrows.forEach((arrow) => (arrow.style.display = "none"));
            allDownArrows.forEach((arrow) => (arrow.style.display = "block"));

            // Now open the clicked submenu
            submenu.style.display = "block";
            upArrowMenu.style.display = "block";
            downArrowMenu.style.display = "none";
          }
        });
      }
    });

  });
  var cat_bottom = document.querySelectorAll('.category-bottom');
  cat_bottom.forEach(ele => {
    ele.addEventListener('click', () => {
      var jsMenu = document.querySelector('js-menu-mobile-content');
      if(jsMenu){
      jsMenu.classList.add('open_menu');
      }
    });
  });

  if (window.location.href !== 'https://lgparts.com/pages/home') {
    $('.category-bottom').click(function () {
      // alert()
      $('body').addClass('open_menu');
    });

  }

  $(document).ready(function () {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      // body: JSON.stringify({ updates })
    })
      .then(response => {

        return response.json();
      }).then(data => {
        var cartscountss = data.item_count;
        console.log("Dddd", data.item_count)
        $(".js-cart-count").html(data.item_count);
        $(document).find(".bottom-nav .push_side .js-cart-count").html(data.item_count);

      })
      .catch((error) => {
        console.error('Error:', error);
      });
  })